import { render, staticRenderFns } from "./DadosProcesso.vue?vue&type=template&id=1b0404d3&"
import script from "./DadosProcesso.vue?vue&type=script&lang=js&"
export * from "./DadosProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports